import React, { useContext } from 'react';
import AppContext from '../context/Context';
import SecurityRoutes from '../routes/SecurityRoutes';

const SecurityLayout = () => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <SecurityRoutes />
            </div>
}

export default SecurityLayout;